import imageDe from '../images/de/uploader-oneTouchUltraMini-1.png';
import imageEn from '../images/en/uploader-oneTouchUltraMini-1.png';
import imageEs from '../images/es/uploader-oneTouchUltraMini-1.png';
import imageFi from '../images/fi/uploader-oneTouchUltraMini-1.png';
import imageFr from '../images/fr/uploader-oneTouchUltraMini-1.png';
import imageIt from '../images/it/uploader-oneTouchUltraMini-1.png';
import imageNo from '../images/no/uploader-oneTouchUltraMini-1.png';
import imageSv from '../images/sv/uploader-oneTouchUltraMini-1.png';

export const uploaderSelectDeviceImage = {
  de() {
    return imageDe;
  },
  en() {
    return imageEn;
  },
  es() {
    return imageEs;
  },
  fi() {
    return imageFi;
  },
  fr() {
    return imageFr;
  },
  it() {
    return imageIt;
  },
  no() {
    return imageNo;
  },
  sv() {
    return imageSv;
  },
};
